<template>
  <toolbar-container>
    <template #toolbar>
      <reports-toolbar />
    </template>

    <v-row class="pa-3 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <simple-line-chart
          :title="$t('label.report_sent_emails')"
          :category-type="emails.categoryType"
          :category="emails.category"
          :series="email_series"
          :dataset="emails.dataset"
          :totals="emails.totals"
          :unit="$t('label.unit_emails')"
        />
      </v-col>
      <v-col
        cols="12"
        class="pa-0 ma-0"
      >
        <simple-line-chart
          :title="$t('label.report_sent_sms')"
          :category-type="sms.categoryType"
          :category="sms.category"
          :series="sms_series"
          :dataset="sms.dataset"
          :totals="sms.totals"
          :unit="$t('label.unit_messages')"
        />
      </v-col>
    </v-row>
  </toolbar-container>
</template>

<script lang="ts">
import Vue from 'vue';

import SimpleLineChart from '@/components/views/reports/SimpleLineChart.vue';
import ReportsToolbar from '@/components/views/reports/ReportsToolbar.vue';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import ReportsStore from '@/store/reports-store';
import { ReportsType } from '@/services/reports';
import { ChartData } from '@/services/reports-utils';

export default Vue.extend({
  name: 'ReportMessages',
  components: {
    SimpleLineChart,
    ReportsToolbar,
  },
  data() {
    return {
      sms_series: [this.$i18n.t('label.report_sent_sms')],
      email_series: [this.$i18n.t('label.report_sent_emails')],
    };
  },
  computed: {
    sms(): ChartData {
      return this.$tstore.getters.reportsSms;
    },
    emails(): ChartData {
      return this.$tstore.getters.reportsEmails;
    },
  },
  created() {
    loadStoreModule(this, 'reports', ReportsStore, async () => {
      this.$tstore.dispatch('updateReports', { reportsType: ReportsType.Messages });
    });
  },
  beforeDestroy() {
    unloadStoreModule(this, 'reports', async () => { this.$tstore.dispatch('resetReports'); });
  },
  methods: {},
});

</script>
